const RESET_STORE = 'COMMON/RESET_STORE';

export { RESET_STORE };

export default {
  RESET_STORE,
};
